import {
	Sizes,
	generateAnimations,
	destroyAnimations,
	generateTriggers,
} from '../utils';

export class PageMouseHover {
	constructor( options = {} ) {
		// General
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
		};
		this.isEnable = false;

		// Animations
		this.timelines = null;
		this.textInstances = null;

		// Triggers Data
		this.enterTrigger = {};
		this.leaveTrigger = {};
		this.enterFn = [];
		this.leaveFn = [];
		this.triggerTimer = [];

		this.enterFunc = null;
		this.leaveFunc = null;
	}

	init() {
		if (
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const enterSettings = this.options.mouseenter;
		const leaveSettings = this.options.mouseleave;
		const [ theTimelines, theTextInstance ] = generateAnimations(
			null,
			this.options.animations
		);
		this.timelines = theTimelines;
		this.textInstances = theTextInstance;

		if ( enterSettings ) {
			this.enterFn[ 0 ] = generateTriggers(
				enterSettings,
				this.timelines,
				this.enterTrigger,
				this.triggerTimer,
				0
			);

			this.enterFunc = () => this.#enter();
			document.addEventListener( 'mouseenter', this.enterFunc );
		}
		if ( leaveSettings ) {
			this.leaveFn[ 0 ] = generateTriggers(
				leaveSettings,
				this.timelines,
				this.leaveTrigger,
				this.triggerTimer,
				0
			);

			this.leaveFunc = () => this.#leave();
			document.addEventListener( 'mouseleave', this.leaveFunc );
		}
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		if ( this.enterFunc ) {
			document.removeEventListener( 'mouseenter', this.enterFunc );
		}
		if ( this.leaveFunc ) {
			document.removeEventListener( 'mouseleave', this.leaveFunc );
		}
		this.enterFn[ 0 ]?.kill();
		this.leaveFn[ 0 ]?.kill();
		destroyAnimations(
			null,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		this.timelines = null;
		this.textInstances = null;
		this.enterTrigger = {};
		this.leaveTrigger = {};
		this.enterFn = [];
		this.leaveFn = [];
		this.triggerTimer = [];
		this.enterFunc = null;
		this.leaveFunc = null;
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.sizes = null;
		this.options = null;
		this.isEnable = null;
		this.timelines = null;
		this.textInstances = null;
		this.enterTrigger = null;
		this.leaveTrigger = null;
		this.enterFn = null;
		this.leaveFn = null;
		this.triggerTimer = null;
		this.enterFunc = null;
		this.leaveFunc = null;
	}

	#enter() {
		this.enterFn[ 0 ]?.run();
	}

	#leave() {
		this.leaveFn[ 0 ]?.run();
	}
}
